export default __webpack_public_path__ + "static/media/unde.0924bf70.jpg";